var l = Object.defineProperty;
var n = (t, e, r) => e in t ? l(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var o = (t, e, r) => (n(t, typeof e != "symbol" ? e + "" : e, r), r);
import { Parser as p } from "../Parser.js";
import { mapValue as c, parseNDigits as m } from "../utils.js";
class h extends p {
  constructor() {
    super(...arguments);
    o(this, "priority", 30);
    o(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, s) {
    const a = (i) => Math.trunc(i * Math.pow(10, -s.length + 3));
    return c(m(s.length, r), a);
  }
  set(r, s, a) {
    return r.setMilliseconds(a), r;
  }
}
export {
  h as FractionOfSecondParser
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/parse/_lib/parsers/FractionOfSecondParser.js
// module id = 1372
// module chunks = 41